import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Spin, Tooltip } from "antd";
import moment from "moment";

import {
  setRecordDates,
  setSearchText,
} from "../../../../redux/store/common/commonDuck";

const MainDashboard = ({ orderDeliveryStatus, orderLoading }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const setDates = (value) => dispatch(setRecordDates(value));

  return (
    <Row className="order-component-box main-component-box">
      {(isLoading || orderLoading) && <Spin />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">
          판매/배송
          <span
            className={`gray-font`}
            style={{
              marginLeft: "8px",
            }}
          >
            최근 14일 기준
          </span>
        </h2>
        {/*<span className={`gray-font`}>최근 16:00</span>*/}
      </div>
      <div
        className={`order-component-info`}
        style={{
          height: "100%",
          padding: "2.5rem 1rem",
        }}
      >
        <div
          className={`order-component-each main-component-sell`}
          style={{
            gap: "1%",
          }}
        >
          <>
            <Row
              className={`order-component-each-detail dash-cursor`}
              align={"middle"}
              style={{
                gap: "8px",
                rowGap: "8px",
                width: "20%",
              }}
              onClick={() => {
                history.push(`/salesManage/order?type=paid`);
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: "1.8rem",
                }}
              >
                {orderDeliveryStatus.newOrder ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: "fit-content",
                  }}
                >
                  결제완료
                </span>
              </div>
            </Row>
            <img
              style={{
                width: "3%",
                height: "auto",
              }}
              alt={"닫기 버튼"}
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            <Row
              className={`order-component-each-detail dash-cursor`}
              align={"middle"}
              style={{
                gap: "8px",
                rowGap: "8px",
                width: "20%",
              }}
              onClick={() => {
                history.push(`/salesManage/order?type=delivery_ready`);
                // if (user && user.role && user.role === "super_admin") {
                // 	setIsSearchText("delivery_ready");
                // 	if (orderDeliveryStatus.deliveryReady?.length > 0) {
                // 		setDates({
                // 			startDate: moment(
                // 				orderDeliveryStatus.deliveryReady[
                // 					orderDeliveryStatus.deliveryReady?.length - 1
                // 				].payment_created_at
                // 			).startOf("day"),
                // 			endDate: moment(
                // 				orderDeliveryStatus.deliveryReady[0].payment_created_at
                // 			).endOf("day"),
                // 		});
                // 	} else {
                // 		setDates({
                // 			startDate: moment().subtract(7, "days").startOf("day"),
                // 			endDate: moment().endOf("day"),
                // 		});
                // 	}
                // 	history.push(`/salesManage/delivery`);
                // } else {
                // 	history.push(`/salesManage/order?type=delivery_ready`);
                // }
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: "1.8rem",
                }}
              >
                {/*{orderDeliveryStatus.deliveryReady?.length ?? 0}*/}
                {orderDeliveryStatus.deliveryReady ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: "fit-content",
                  }}
                >
                  배송준비중
                </span>
                <div className={`delivery-detail-div`}>
                  <span style={{ color: "#ff8000" }}>
                    {orderDeliveryStatus?.delivery12 ?? 0}
                  </span>
                  /
                  <span style={{ color: "#df1d1d" }}>
                    {orderDeliveryStatus?.delivery24 ?? 0}
                  </span>
                </div>
              </div>
            </Row>
            <img
              style={{
                width: "3%",
                height: "auto",
              }}
              alt={"닫기 버튼"}
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            <Row
              className={`order-component-each-detail dash-cursor`}
              align={"middle"}
              style={{
                gap: "8px",
                rowGap: "8px",
                width: "20%",
              }}
              onClick={() => {
                if (user && user.role && user.role === "super_admin") {
                  setIsSearchText("delivery_shipping");
                  if (orderDeliveryStatus.deliveryShipping?.length > 0) {
                    setDates({
                      startDate: moment(
                        orderDeliveryStatus.deliveryShipping[
                          orderDeliveryStatus.deliveryShipping?.length - 1
                        ].payment_created_at,
                      ).startOf("day"),
                      endDate: moment(
                        orderDeliveryStatus.deliveryShipping[0]
                          .payment_created_at,
                      ).endOf("day"),
                    });
                  } else {
                    setDates({
                      startDate: moment().subtract(7, "days").startOf("day"),
                      endDate: moment().endOf("day"),
                    });
                  }
                  history.push(`/salesManage/delivery`);
                } else {
                  history.push(`/salesManage/order?type=delivery_shipping`);
                }
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: "1.8rem",
                }}
              >
                {orderDeliveryStatus.deliveryShipping?.length ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: "fit-content",
                  }}
                >
                  배송중
                </span>
              </div>
              <div className={`delivery-delay-div`}>
                <span style={{ color: "#df1d1d", paddingLeft: "1.2rem" }}>
                  {orderDeliveryStatus.deliveryShipping7delay ?? 0}
                </span>
                <div className={`delivery-delay-text`}>
                  <Tooltip
                    title={`최근 30일 기준\n배송 일주일 이상 지연 대상`}
                    trigger={`click`}
                    overlayStyle={{
                      whiteSpace: "pre-wrap",
                      fontSize: "0.75rem",
                    }}
                    overlayInnerStyle={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={`${process.env.REACT_APP_HOST}/assets/images/commission/notice.png`}
                      alt={`faq 접기열기 아이콘`}
                      width={16}
                      height={16}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </Row>
            <img
              style={{
                width: "3%",
                height: "auto",
              }}
              alt={"닫기 버튼"}
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            <Row
              className={`order-component-each-detail dash-cursor`}
              align={"middle"}
              style={{
                gap: "8px",
                rowGap: "8px",
                width: "20%",
              }}
              onClick={() => {
                if (user && user.role && user.role === "super_admin") {
                  setIsSearchText("delivery_complete");
                  if (orderDeliveryStatus.deliveryComplete?.length > 0) {
                    setDates({
                      startDate: moment(
                        orderDeliveryStatus.deliveryComplete[
                          orderDeliveryStatus.deliveryComplete?.length - 1
                        ].payment_created_at,
                      ).startOf("day"),
                      endDate: moment(
                        orderDeliveryStatus.deliveryComplete[0]
                          .payment_created_at,
                      ).endOf("day"),
                    });
                  } else {
                    setDates({
                      startDate: moment().subtract(7, "days").startOf("day"),
                      endDate: moment().endOf("day"),
                    });
                  }
                  history.push(`/salesManage/delivery`);
                } else {
                  history.push(`/salesManage/order?type=delivery_complete`);
                }
              }}
            >
              <h4
                className={`order-each-detail-title`}
                style={{
                  fontSize: "1.8rem",
                }}
              >
                {orderDeliveryStatus.deliveryComplete?.length ?? 0}
              </h4>
              <div className={`main-dashboard-text-div`}>
                <span
                  style={{
                    width: "fit-content",
                  }}
                >
                  배송완료
                </span>
              </div>
            </Row>
          </>
        </div>
      </div>
    </Row>
  );
};
export default MainDashboard;
